import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { Observable } from "rxjs";
import { map } from 'rxjs/operators';
import { BrowserAttributes } from "../../browser/detect.browser";
import { DeployedEnv } from "../../env";
import { APIProxy } from "./api.proxy";
import { HttpObservable } from "./http.wrapper";

declare var __ris_global_vars__:any;

@Injectable()
export class AssetProxy {
	constructor(private http:HttpClient,private browser:BrowserAttributes,
				private apiProxy: APIProxy,private env:DeployedEnv) {
	}

	// remove this because it is not used anyway and we want to avoid possible 
	// security issues.
	// public getAsScript(url:string, localResource:boolean) {
	// 	return this.get(url, localResource, 'text')
	// 		.pipe(map(scriptText=>{
	// 			/* tslint:disable */
	// 			eval(scriptText);
	// 			/* tslint:enable */
	// 			return true;
	// 		}));
	// }

	public getAsStyleFromApi(controller:string,f:string) {
		let apiUrl=this.env.apiUrl();

		return this.get(apiUrl+"/"+controller+"/"+f,false, 'text')
			.pipe(map(cssText=>{
				let x = document.createElement("STYLE");
				x.textContent=cssText;
				document.getElementsByTagName("head")[0].appendChild(x);
				return true;
			}));
	}

	public getAsJson(url:string, localResource:boolean) {
		return this.get(url, localResource, 'json');
	}

	public getAsText(url:string, localResource:boolean) {
		return this.get(url, localResource, 'text/plain');
	}

	public getAbsoluteLocalResourceURL(url:string){
		let relativeUrl = this.getRelativeLocalResourceURL(url,false);
		return `${window.location.protocol}//${window.location.hostname}${window.location.port!==""?':'+window.location.port:""}${relativeUrl}`;
		//let baseUrl = winUrl.
	}

	// use includeVersion if you want to actually get the real URL to the actual reasource
	public getRelativeLocalResourceURL(url:string,includeVersion:boolean){
		let finalUrl:string;
		finalUrl = __ris_global_vars__.baseResourceUrl;
		if (!finalUrl.endsWith("/")){
			finalUrl=finalUrl+"/";
		}
		if (includeVersion && __ris_global_vars__.version) {
			finalUrl += __ris_global_vars__.version+"/";
		}
		if (url.startsWith("/")) {
			finalUrl = finalUrl + url.substr(1);
		} else {
			finalUrl = finalUrl + url;
		}
		if (this.browser.isNode()){
			finalUrl=__ris_global_vars__.assetsServer+finalUrl;
		}
		return finalUrl;
	}
	/**
		* perform a get request from the server for retrieving data from a url
		* @url relative url
		*/
	public get(url:string, localResource:boolean, responseType) : Observable<any> {
		let finalUrl:string;

		if (localResource) {
			finalUrl=this.getRelativeLocalResourceURL(url,true);
		} else {
			finalUrl = url;
		}

		let headers = new HttpHeaders();

		return this.http.get(finalUrl, {
			headers, responseType
		});
	}

	public getStaticAssetByCode(code: string): HttpObservable<Blob> {
		return this.apiProxy.getBlob("StaticAsset","GetStaticAssetByCode",
			{pName:"code", pVal:code}, null, true, true);
	}
}

